import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const TravellingPolicy = (props) => {
    const [TravellingPolicyID, setTravellingPolicyID] = useState('');
    const [TravellingPolicyType, setTravellingPolicyType] = useState('');
    const [CategoryID, setCategoryID] = useState('');
    const [ModeOfTravelID, setModeOfTravelID] = useState('');
    const [UpperCeilingCapitalCities, setUpperCeilingCapitalCities] = useState('');
    const [UpperCeilingNonCapitalCities, setUpperCeilingNonCapitalCities] = useState('');
    const [Countrycmb, setCountrycmb] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responseCombo, fetchComboData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();
    const [Categorycmb, setCategorycmb] = useState([]);
    const [CategoryDataResponse, fetchCategoryData] = UseFetchData();
    const [ModeOfTravelcmb, setModeOfTravelcmb] = useState([]);
    const [ModeOfTravelResponse, fetchModeOfTravelData] = UseFetchData();
    const [ModeOfTravelTypecmb, setTravellingPolicyTypecmb] = useState([]);
    const [ModeOfTravelTypeResponse, fetchModeOfTravelType] = UseFetchData();
    const [TravelTypecmb, setTravelTypecmb] = useState([]);
    // const validationSchema = Yup.object({
    //     CountryID:Yup.string().required('Required!'),
    //     StateName:Yup.string().required('Required!'),
    //     StateCode:Yup.string().required('Required!'),
    // });

    const PopulateCategorydata = () => {
        var bodyFormData = new FormData();
        fetchCategoryData("Primary/ComboData", bodyFormData);
    }
    const CategoryData = (options) => {
        debugger;
        if (options !== undefined) {
            let Category = options.map((data) => (
                <option key={data.Category} value={data.CategoryID}>
                    {data.Category}
                </option>
            ));
            setCategorycmb(Category);
        }
    };

    useEffect(() => {
        debugger;
        if (CategoryDataResponse !== undefined) {
            if (CategoryDataResponse["Category"] !== undefined) {
                CategoryData(CategoryDataResponse["Category"]);
            }
        }
    }, [CategoryDataResponse]);


    // const ModeOfTravelType = () => {
    //     var bodyFormData = new FormData();
    //     fetchModeOfTravelType("Primary/ComboData", bodyFormData);
    // }
    // const ModeOfTravelTypeData = (options) => {
    //     debugger;
    //     if (options !== undefined) {
    //         let ModeOfTravelType = options.map((data) => (
    //             <option key={data.ModeOfTravelType} value={data.ModeOfTravelID}>
    //                 {data.ModeOfTravelTypey}
    //             </option>
    //         ));
    //         setModeOfTravelTypecmb(ModeOfTravelType);
    //     }
    // };

    // useEffect(() => {
    //     debugger;
    //     if (ModeOfTravelTypeResponse !== undefined) {
    //         if (ModeOfTravelTypeResponse["ModeOfTravelType"] !== undefined) {
    //             ModeOfTravelTypeData(ModeOfTravelTypeResponse["ModeOfTravelType"]);
    //         }
    //     }
    // }, [ModeOfTravelTypeResponse]);


    const Modeoftraveldata = () => {
        var bodyFormData = new FormData();
        fetchModeOfTravelData("Primary/ComboData", bodyFormData);
    }
    const ModeoftravelData = (options) => {
        debugger;
        if (options !== undefined) {
            let ModeOfTravel = options.map((data) => (
                <option key={data.ModeOfTravel} value={data.ModeOfTravelID}>
                    {data.ModeOfTravel}
                </option>
            ));
            setModeOfTravelcmb(ModeOfTravel);
        }
    };

    useEffect(() => {
        debugger;
        if (ModeOfTravelResponse !== undefined) {
            if (ModeOfTravelResponse["ModeOfTravel"] !== undefined) {
                ModeoftravelData(ModeOfTravelResponse["ModeOfTravel"]);
            }
        }
    }, [ModeOfTravelResponse]);


    useEffect(() => {
        PopulateCategorydata();
        Modeoftraveldata();
        // ModeOfTravelType();
    }, [])

    const onSubmit = values => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Travelling Policy');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.TravellingPolicyType);
        bodyFormData.append("Value2", values.CategoryID);
        bodyFormData.append("Value3", values.ModeOfTravelID);
        bodyFormData.append("Value4", values.UpperCeilingCapitalCities);
        bodyFormData.append("Value5", values.UpperCeilingNonCapitalCities);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Travelling Policy');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }


    // const CountryData = () => {
    //     var bodyFormData = new FormData();
    //     bodyFormData.append("Type", 'Country');
    //     fetchComboData("Primary/List", bodyFormData);
    // }
    const TravelTypeOption = [
        { key: "Local Travelling", value: "Local Travelling" },
        { key: "OutStation Travelling", value: "OutStation Travelling" },

    ];

    const Traveldataopt = () => {
        debugger;
        let TravelCombo = TravelTypeOption.map((data) =>
            <option
                key={data.key} value={data.value}
            >
                {data.key}
            </option>
        );
        setTravelTypecmb(TravelCombo);
    };

    useEffect(() => {
        debugger;
        Traveldataopt(responseCombo);
    }, [responseCombo])

    useEffect(() => {
        if (response.Response === true) {
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if (response.Response === false) {
            alert('Save Failed.')
        }
    }, [response])


    useEffect(() => {
        if (responseGetData.length > 0) {
            setTravellingPolicyID(responseGetData[0].TravellingPolicyID);
            setTravellingPolicyType(responseGetData[0].TravellingPolicyType);
            setCategoryID(responseGetData[0].CategoryID);
            setModeOfTravelID(responseGetData[0].ModeOfTravelID);
            setUpperCeilingCapitalCities(responseGetData[0].UpperCeilingCapitalCities);
            setUpperCeilingNonCapitalCities(responseGetData[0].UpperCeilingNonCapitalCities);
            setTravellingPolicyTypecmb(responseGetData[0].ModeOfTravelTypecmb);
        }
    }, [responseGetData])

    useEffect(() => {
        //CountryData();
        if (props.PKID !== '') {
            getByIDData();
        }
    }, [])

    return (
        <div>
            <Formik initialValues={{
                CategoryID: CategoryID, TravellingPolicyID: TravellingPolicyID, TravellingPolicyType: TravellingPolicyType,
              ModeOfTravelTypecmb:ModeOfTravelTypecmb , ModeOfTravelID: ModeOfTravelID, UpperCeilingCapitalCities: UpperCeilingCapitalCities, UpperCeilingNonCapitalCities: UpperCeilingNonCapitalCities
            }}
                // validationSchema = {validationSchema}
                onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='select'
                                    type='text'
                                    label='Travelling Policy Type'
                                    name='TravellingPolicyType'
                                    options={TravelTypecmb}
                                    onChange={(e) => setTravellingPolicyType(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='select'
                                    type='text'
                                    label='Category'
                                    name='CategoryID'
                                    options={Categorycmb}
                                    onChange={(e) => setCategoryID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='select'
                                    type='text'
                                    label='Mode Of Travel'
                                    name='ModeOfTravelID'
                                    options={ModeOfTravelcmb}
                                    onChange={(e) => setModeOfTravelID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Upper Ceiling Capital Cities'
                                    name='UpperCeilingCapitalCities'
                                    onChange={(e) => setUpperCeilingCapitalCities(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Upper Ceiling Non Capital Cities'
                                    name='UpperCeilingNonCapitalCities'
                                    onChange={(e) => setUpperCeilingNonCapitalCities(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default TravellingPolicy;
